import {Button} from "@mui/material";
import {Link} from "react-router-dom";
import {routesBeforeLogin} from "../../../routes/router";
import NavMenu from "../NavMenu";
import "../../../style/navMenu/navMenu.css";

const PublicAppBar = () => {
    const routes = routesBeforeLogin();
    return (
        //Nav Menu for public users
        <NavMenu routes={routes}>
            {/*<Button
                variant="contained"
                color="primary"
                component={Link}
                style={{marginRight: 10}}
                startIcon={<IoMdLogIn/>}
                to='/login'>
                LOG IN
            </Button>*/}
            <Button
                color={"primary"}
                variant={"contained"}
                className={"roundButton"}
                size={"small"}
                component={Link}
                to={"/registration"}>
                Join Community
            </Button>
        </NavMenu>
    )
}
export default PublicAppBar;
